var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { getGraphWidgetStyles } from './GraphWidgetStyles';
import { Divider, LILAC_400, WHITE, getTestId, isValidObject, Typography, BLACK_900, DynamicSvg } from '@airtel/air-design-system';
import { CalloutWidget } from '../callout-widget';
import { InfoSummaryWidget } from '../info-summary-widget';
import { DropdownWidget } from '../dropdown-widget';
import { SingleField } from './components/single-field';
export var GraphWidgetComponent = props => {
  var _a, _b, _c;
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'GraphWidget' : _props$testID,
    style = props.style,
    callout = props.callout,
    _props$showDivider = props.showDivider,
    showDivider = _props$showDivider === void 0 ? false : _props$showDivider,
    dividerProps = props.dividerProps,
    infoSummaryProps = props.infoSummaryProps,
    _props$dropdownArray = props.dropdownArray,
    dropdownArray = _props$dropdownArray === void 0 ? [] : _props$dropdownArray,
    graphType = props.graphType,
    graphData = props.graphData,
    _props$noDataText = props.noDataText,
    noDataText = _props$noDataText === void 0 ? 'No Data Available!' : _props$noDataText,
    _props$show = props.show,
    show = _props$show === void 0 ? true : _props$show,
    onUserAction = props.onUserAction;
  if (!show) return null;
  var GraphWidgetStyles = getGraphWidgetStyles();
  var _useState = useState([]),
    customDropdownArray = _useState[0],
    setCustomDropdownArray = _useState[1];
  var onSelectDropdownValue = (_a, _b, dropdown) => {
    var id = _a.id,
      onSelectMetaData = __rest(_a, ["id"]);
    var data = _b.data,
      searchedTerm = _b.searchedTerm,
      item = _b.item;
    var dropdownFilterKey = dropdown === null || dropdown === void 0 ? void 0 : dropdown.dropdownFilterKey;
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onSelectMetaData), {
      data,
      searchedTerm,
      item,
      dropdownFilterKey
    });
  };
  useEffect(() => {
    setCustomDropdownArray(dropdownArray);
  }, [JSON.stringify(dropdownArray)]);
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [GraphWidgetStyles.summaryContainer, style]
  }, {
    children: [isValidObject(callout) && _jsx(View, Object.assign({
      style: [GraphWidgetStyles.calloutContainer]
    }, {
      children: _jsx(CalloutWidget, Object.assign({}, callout, {
        onUserAction: onUserAction
      }))
    })), showDivider && _jsx(Divider, Object.assign({
      style: GraphWidgetStyles.dividerContainer,
      height: 2,
      color: LILAC_400,
      shadowColor: WHITE
    }, dividerProps)), _jsxs(View, {
      children: [_jsx(InfoSummaryWidget, Object.assign({
        outerContainerStyle: GraphWidgetStyles.infoSummaryContainer,
        showShadow: false
      }, infoSummaryProps, {
        onUserAction: onUserAction
      })), customDropdownArray.length > 0 && _jsx(View, Object.assign({
        style: [GraphWidgetStyles.dropdownContainerWrapper]
      }, {
        children: customDropdownArray.map((dropdown, index) => {
          var _a;
          return isValidObject(dropdown) && _jsx(View, Object.assign({
            style: index > 0 ? [GraphWidgetStyles.dropdownContainer, dropdown === null || dropdown === void 0 ? void 0 : dropdown.dropdownWrapperStyle] : [dropdown === null || dropdown === void 0 ? void 0 : dropdown.dropdownWrapperStyle]
          }, {
            children: _jsx(DropdownWidget, Object.assign({}, dropdown, {
              onUserAction: (_a, _b) => {
                var id = _a.id,
                  onSelectMetaData = __rest(_a, ["id"]);
                var data = _b.data,
                  searchedTerm = _b.searchedTerm,
                  item = _b.item;
                onSelectDropdownValue(Object.assign({
                  id
                }, onSelectMetaData), {
                  data,
                  searchedTerm,
                  item
                }, dropdown);
              }
            }))
          }), (_a = dropdown === null || dropdown === void 0 ? void 0 : dropdown.id) !== null && _a !== void 0 ? _a : index + ' key');
        })
      })), ((_a = graphData === null || graphData === void 0 ? void 0 : graphData.data) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_c = (_b = graphData === null || graphData === void 0 ? void 0 : graphData.chartData) === null || _b === void 0 ? void 0 : _b.datasets) === null || _c === void 0 ? void 0 : _c.length) > 0 ? _jsx(_Fragment, {
        children: isValidObject(graphData) && _jsx(SingleField, Object.assign({}, props, {
          graphData: graphData,
          graphType: graphType
        }))
      }) : _jsxs(View, Object.assign({
        style: GraphWidgetStyles.no_data_available
      }, {
        children: [_jsx(DynamicSvg, {
          iconName: "AlertMediumIcon",
          height: 18,
          width: 18
        }), _jsx(Typography, {
          text: noDataText,
          type: "body-para-sm-bold",
          color: BLACK_900
        })]
      }))]
    })]
  }));
};
GraphWidgetComponent.genericRendererKey = 'AirGraphWidget';